/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Danish (Denmark)
export default {
  'goal-actions.archive-goal.generic-error-title': 'Målet kunne ikke arkiveres',
  'goal-actions.copy-goal.cancel': 'Annuller',
  'goal-actions.copy-goal.close-modal': 'Luk modal',
  'goal-actions.copy-goal.error': 'Giv dit mål et navn, så alle ved, hvad det går ud på',
  'goal-actions.copy-goal.failed-description': 'Der opstod en fejl under kloning af målet. Prøv igen senere.',
  'goal-actions.copy-goal.failed-description-forbidden': 'Du har ikke tilladelse til at kopiere dette mål.',
  'goal-actions.copy-goal.failed-title': 'Vi kunne ikke klone dette mål.',
  'goal-actions.copy-goal.followers': 'Følgere',
  'goal-actions.copy-goal.goal-name': 'Målnavn',
  'goal-actions.copy-goal.include': 'Inkluder',
  'goal-actions.copy-goal.links': 'Links',
  'goal-actions.copy-goal.submit': 'Send',
  'goal-actions.copy-goal.success-description': 'Målet er blevet klonet.',
  'goal-actions.copy-goal.success-link': 'Vis klonet mål.',
  'goal-actions.copy-goal.success-title': 'Målet {goalName} blev klonet.',
  'goal-actions.copy-goal.title': 'Kopiér mål',
  'goal-actions.follow-goal.follow-error-title': 'Målet kunne ikke følges',
  'goal-actions.follow-goal.unfollow-error-title': 'Kunne ikke stoppe med at følge målet',
  'goal-actions.goal-actions.archive-error-title': 'mål kunne ikke gendannes',
  'goal-actions.goal-actions.archive-goal': 'Arkivér mål',
  'goal-actions.goal-actions.archive-restore-error-description': 'målændringer kunne ikke gemmes. Prøv igen senere.',
  'goal-actions.goal-actions.copy-goal': 'Kopiér mål',
  'goal-actions.goal-actions.copy-link': 'Kopiér link',
  'goal-actions.goal-actions.follow': 'Følg',
  'goal-actions.goal-actions.generic-error-description': 'Der gik noget galt. Prøv igen om et par minutter.',
  'goal-actions.goal-actions.restore-goal': 'Gendan mål',
  'goal-actions.goal-actions.share': 'Del',
  'goal-actions.goal-actions.show-more': 'Vis mere',
  'goal-actions.goal-actions.unfollow': 'Ophør med at følge',
  'goal-actions.goal-content.follow-confirmation-description':
    'Vi sender dig en oversigt med opdateringerne af alle mål, du følger, i den første uge af næste måned.',
  'goal-actions.goal-content.follow-confirmation-title': '🙌🏼 Du følger nu dette mål!',
  'goal-actions.restore-goal.generic-error-title': 'Målet kunne ikke gendannes',
};
